import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["src", "alt", "variant", "width", "height"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { memo } from 'react';
import { useCardContext } from '../CardContext';
import * as views from './Image.views';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
export var Image = /*#__PURE__*/memo(function (_ref) {
  var src = _ref.src,
      alt = _ref.alt,
      variant = _ref.variant,
      width = _ref.width,
      height = _ref.height,
      rest = _objectWithoutProperties(_ref, _excluded);

  var cardContext = useCardContext();
  return _jsx(views.Image, _objectSpread({
    src: src,
    alt: alt,
    width: width,
    height: height,
    variant: variant,
    layout: cardContext === null || cardContext === void 0 ? void 0 : cardContext.layout
  }, rest));
});
export default Image;